import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: '登录'
    }
  },

  {
    path: '/application',
    name: 'application',
    component: () => import('../views/Application.vue'),
    meta: {
      title: '管制员申请',
      requiresAuth: true
    }
  },
  {
    path: '/activity',
    name: 'activity',
    redirect: '/events',
    meta: {
      title: '活动中心'
    }
  },
  {
    path: '/events',
    name: 'events',
    component: () => import('../views/events/Events.vue'),
    redirect: '/events/list',
    meta: {
      title: '活动中心',
      requiresAuth: true
    },
    children: [
      {
        path: 'list',
        name: 'events-list',
        component: () => import('../views/events/EventsList.vue'),
        meta: {
          title: '活动列表',
          requiresAuth: true
        }
      },
      {
        path: 'publish',
        name: 'events-publish',
        component: () => import('../views/events/PublishEvent.vue'),
        meta: {
          title: '发布活动',
          requiresAuth: true,
          requiresEventAdmin: true
        }
      },
      {
        path: 'edit/:id',
        name: 'events-edit',
        component: () => import('../views/events/EditEvent.vue'),
        meta: {
          title: '编辑活动',
          requiresAuth: true,
          requiresEventAdmin: true
        }
      },
      {
        path: ':id',
        name: 'event-detail',
        component: () => import('../views/events/EventDetail.vue'),
        meta: {
          title: '活动详情',
          requiresAuth: true
        }
      },
      {
        path: 'my-applications',
        name: 'my-applications',
        component: () => import('../views/events/MyApplications.vue'),
        meta: {
          title: '我的报名',
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/training',
    name: 'training',
    component: () => import('../views/Training.vue'),
    meta: {
      title: '培训'
    }
  },
  {
    path: '/forum',
    name: 'forum',
    component: () => import('../views/Forum.vue'),
    meta: {
      title: '论坛'
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/Profile.vue'),
    meta: {
      title: '个人中心',
      requiresAuth: true
    }
  },
  {
    path: '/profile/:id',
    name: 'other-profile',
    component: () => import('../views/OtherProfile.vue'),
    meta: {
      title: '个人信息',
      requiresAuth: true
    }
  },
  {
    path: '/permissions',
    name: 'permissions',
    component: () => import('../views/PermissionManagement.vue'),
    meta: {
      title: '权限管理',
      requiresAuth: true,
      requiresMemberAdmin: true
    }
  },
  {
    path: '/student-permissions',
    name: 'student-permissions',
    component: () => import('../views/StudentPermissionManagement.vue'),
    meta: {
      title: '学员权限管理',
      requiresAuth: true,
      requiresInstructor: true
    }
  },
  {
    path: '/academy',
    name: 'academy',
    component: () => import('../views/Academy.vue'),
    meta: {
      title: '空管学院'
    },
    children: [
      {
        path: 'exam',
        name: 'academy-exam',
        component: () => import('../views/academy/Exam.vue'),
        meta: {
          title: '考试中心'
        },
        children: [
          {
            path: ':id',
            name: 'exam-detail',
            component: () => import('../views/academy/ExamDetail.vue'),
            meta: {
              title: '考核详情',
              requiresAuth: true
            }
          },
          {
            path: ':id/register',
            name: 'exam-register',
            component: () => import('../views/academy/ExamRegister.vue'),
            meta: {
              title: '考核报名',
              requiresAuth: true
            }
          },
          {
            path: ':id/register/success',
            name: 'register-success',
            component: () => import('../views/academy/RegisterSuccess.vue'),
            meta: {
              title: '报名成功',
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: 'records',
        name: 'academy-records',
        component: () => import('../views/academy/Records.vue'),
        meta: {
          title: '考核记录',
          requiresAuth: true
        },
        children: [
          {
            path: ':id',
            name: 'record-detail',
            component: () => import('../views/academy/RecordDetail.vue'),
            meta: {
              title: '考核记录详情',
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: 'software',
        name: 'academy-software',
        component: () => import('../views/academy/Software.vue'),
        meta: {
          title: '软件下载'
        }
      }
    ]
  },
  {
    path: '/external-links',
    name: 'external-links',
    redirect: '/external-links/submit',
    meta: {
      title: '外链推荐',
      requiresAuth: true
    },
    children: [
      {
        path: 'submit',
        name: 'external-links-submit',
        component: () => import('../views/ExternalLinksSubmit.vue'),
        meta: {
          title: '提交外链',
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/points-shop',
    name: 'points-shop',
    component: () => import('../views/PointsShop.vue'),
    meta: {
      title: '积分商城',
      requiresAuth: true
    }
  },
  {
    path: '/career',
    name: 'career',
    component: () => import('../views/Career.vue'),
    redirect: '/career/overview',
    meta: {
      title: '职业生涯',
      requiresAuth: true
    },
    children: [
      {
        path: 'overview',
        name: 'career-overview',
        component: () => import('../views/career/Overview.vue'),
        meta: {
          title: '职业概览'
        }
      },
      {
        path: 'duty',
        name: 'career-duty',
        component: () => import('../views/career/Duty.vue'),
        meta: {
          title: '值班报备'
        }
      },
      {
        path: 'duty-records',
        name: 'career-duty-records',
        component: () => import('../views/career/DutyRecords.vue'),
        meta: {
          title: '值班记录'
        }
      },
      {
        path: 'control-records',
        name: 'career-control-records',
        component: () => import('../views/career/ControlRecords.vue'),
        meta: {
          title: '管制记录'
        }
      },
      {
        path: 'penalties',
        name: 'career-penalties',
        component: () => import('../views/career/Penalties.vue'),
        meta: {
          title: '处罚记录'
        }
      },
      {
        path: 'trainings',
        name: 'career-trainings',
        component: () => import('../views/career/Trainings.vue'),
        meta: {
          title: '培训记录'
        }
      },
      {
        path: 'certificates',
        name: 'career-certificates',
        component: () => import('../views/career/Certificates.vue'),
        meta: {
          title: '证书管理'
        }
      }
    ]
  },
  {
    path: '/atc-center',
    name: 'atc-center',
    component: () => import('../views/AtcCenter.vue'),
    meta: {
      title: '空管中心',
      requiresAuth: true
    }
  },
  {
    path: '/announcements',
    name: 'announcements',
    component: () => import('../views/announcements/AnnouncementsList.vue'),
    meta: {
      title: '公告列表'
    }
  },
  {
    path: '/announcements/:id',
    name: 'announcement-detail',
    component: () => import('../views/announcements/AnnouncementDetail.vue'),
    meta: {
      title: '公告详情'
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/Admin.vue'),
    meta: {
      title: '管理面板',
      requiresAuth: true,
      requiresInstructor: true
    }
  },
  {
    path: '/admin/announcements',
    name: 'admin-announcements',
    component: () => import('../views/announcements/AdminAnnouncements.vue'),
    meta: {
      title: '公告管理',
      requiresAuth: true,
      requiresInstructor: true
    }
  },
  {
    path: '/admin/review/:id',
    name: 'admin-review',
    component: () => import('../views/AdminReview.vue'),
    meta: {
      title: '申请审核',
      requiresAuth: true,
      requiresInstructor: true
    }
  },
  {
    path: '/admin/system-access',
    name: 'admin-system-access',
    component: () => import('../views/admin/SystemAccess.vue'),
    meta: {
      title: '公开系统管理',
      requiresAuth: true,
      requiresSystemAdmin: true
    }
  },
  {
    path: '/admin/badges',
    name: 'admin-badges',
    component: () => import('../views/admin/BadgeManagement.vue'),
    meta: {
      title: '徽章管理',
      requiresAuth: true,
      requiresInstructor: true
    }
  },
  {
    path: '/admin/badge-assignment',
    name: 'admin-badge-assignment',
    component: () => import('../views/admin/BadgeAssignment.vue'),
    meta: {
      title: '徽章分配管理',
      requiresAuth: true,
      requiresSystemAdmin: true
    }
  },
  {
    path: '/admin/points',
    name: 'admin-points',
    component: () => import('../views/admin/PointsManagement.vue'),
    meta: {
      title: '积分管理',
      requiresAuth: true,
      requiresSystemAdmin: true
    }
  },
  {
    path: '/admin/software-management',
    name: 'admin-software-management',
    component: () => import('../views/admin/SoftwareManagement.vue'),
    meta: {
      title: '软件管理',
      requiresAuth: true,
      requiresSystemAdmin: true
    }
  },
  {
    path: '/admin/question-bank',
    name: 'admin-question-bank',
    component: () => import('../views/admin/QuestionBank.vue'),
    meta: {
      title: '题库管理',
      requiresAuth: true,
      requiresInstructor: true
    }
  },
  {
    path: '/admin/paper-builder',
    name: 'admin-paper-builder',
    component: () => import('../views/admin/PaperBuilder.vue'),
    meta: {
      title: '智能组卷',
      requiresAuth: true,
      requiresInstructor: true
    }
  },
  {
    path: '/admin/exam-management',
    name: 'admin-exam-management',
    component: () => import('../views/admin/ExamManagement.vue'),
    meta: {
      title: '学员考试管理',
      requiresAuth: true,
      requiresInstructor: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 添加详细调试信息
  console.log('🔍 路由守卫详细检查:', {
    to: {
      name: to.name,
      path: to.path,
      fullPath: to.fullPath,
      matched: to.matched.map(m => ({ name: m.name, path: m.path }))
    },
    from: {
      name: from?.name,
      path: from?.path
    }
  })

  // 设置页面标题
  document.title = `${to.meta.title} - 空管人生`

  // 检查pilot token是否存在且未过期
  const pilotToken = localStorage.getItem('pilot_token')
  const tokenExpires = localStorage.getItem('pilot_token_expires')
  const pilotUser = localStorage.getItem('pilot_user')
  
  // 检查是否已登录
  const isLoggedIn = pilotToken && tokenExpires && pilotUser && new Date(tokenExpires) > new Date()
  
  console.log('🔍 登录状态检查:', {
    isLoggedIn,
    pilotToken: !!pilotToken,
    tokenExpires,
    pilotUser: !!pilotUser,
    currentTime: new Date().toISOString()
  })
  
  // 首页不设防，可以随意访问
  console.log('🔍 首页判断检查:', {
    toName: to.name,
    toPath: to.path,
    condition1: to.name === 'home',
    condition2: to.path === '/',
    shouldPass: to.name === 'home' || to.path === '/'
  })
  
  if (to.name === 'home' || to.path === '/') {
    console.log('✅ 首页访问，直接通过')
    next()
    return
  }
  
  console.log('❌ 不是首页，继续其他检查')
  // 如果未登录且不是访问登录页面，重定向到登录页面
  // 但排除首页，让所有人都能访问首页
  if (!isLoggedIn && to.name !== 'login' && to.name !== 'home' && to.path !== '/') {
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }
  // 如果已登录且访问登录页面，重定向到首页
  if (isLoggedIn && to.name === 'login') {
    next({ name: 'home' })
    return
  }
  // 检查是否需要登录权限（排除首页）
  if (to.meta.requiresAuth && !isLoggedIn) {
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }
  // 检查申请页面权限：atc_level>0的用户无法访问申请页面
  if (to.name === 'application' && isLoggedIn && pilotUser) {
    const user = JSON.parse(pilotUser)
    if (user.atc_level > 0) {
      next({ name: 'home' })
      return
    }
  }
  // 检查atc_level=0用户的访问权限
  if (isLoggedIn && pilotUser) {
    const user = JSON.parse(pilotUser)
    if (user.atc_level === 0) {
      // atc_level=0的用户可以访问申请页面、个人中心和首页
      if (to.name !== 'application' && to.name !== 'profile' && to.name !== 'home' && to.path !== '/') {
        next({ name: 'application' })
        return
      }
    }
  }
  // 检查是否需要管理员权限
  if (to.meta.requiresAdmin) {
    if (pilotUser) {
      const user = JSON.parse(pilotUser)
      if (user.atc_level < 5) { // 假设5级以上为管理员
        next({ name: 'home' })
        return
      }
    }
  }
  // 检查是否需要教员权限
  if (to.meta.requiresInstructor) {
    if (pilotUser) {
      const user = JSON.parse(pilotUser)
      if (user.is_ins !== 1) { // 只有is_ins=1的用户才能访问
        next({ name: 'home' })
        return
      }
    }
  }
  // 检查是否需要系统管理员权限
  if (to.meta.requiresSystemAdmin) {
    if (pilotUser) {
      const pilotPermissions = localStorage.getItem('pilot_permissions')
      if (pilotPermissions) {
        const permissions = JSON.parse(pilotPermissions)
        // 只需要系统管理权限即可
        if (permissions.admin_system !== 1) {
          next({ name: 'home' })
          return
        }
      } else {
        next({ name: 'home' })
        return
      }
    } else {
      next({ name: 'home' })
      return
    }
  }
  // 检查是否需要活动管理员权限
  if (to.meta.requiresEventAdmin) {
    if (pilotUser) {
      const pilotPermissions = localStorage.getItem('pilot_permissions')
      if (pilotPermissions) {
        const permissions = JSON.parse(pilotPermissions)
        const hasAdminEvent = permissions.admin_event === 1
        const hasAdminSystem = permissions.admin_system === 1
        // 只需要活动管理权限或系统管理权限即可
        if (!hasAdminEvent && !hasAdminSystem) {
          next({ name: 'home' })
          return
        }
      } else {
        next({ name: 'home' })
        return
      }
    } else {
      next({ name: 'home' })
      return
    }
  }
  // 检查是否需要人员管理员权限
  if (to.meta.requiresMemberAdmin) {
    if (pilotUser) {
      const pilotPermissions = localStorage.getItem('pilot_permissions')
      if (pilotPermissions) {
        const permissions = JSON.parse(pilotPermissions)
        // 只需要人员管理权限或系统管理权限即可
        if (permissions.admin_member !== 1 && permissions.admin_system !== 1) {
          next({ name: 'home' })
          return
        }
      } else {
        next({ name: 'home' })
        return
      }
    } else {
      next({ name: 'home' })
      return
    }
  }
  next()
})

// 全局后置钩子，检查用户权限并重定向
router.afterEach((to) => {
  // 如果不是登录页面和首页，检查用户权限
  if (to.name !== 'login' && to.name !== 'home' && to.path !== '/') {
    const pilotUser = localStorage.getItem('pilot_user')
    if (pilotUser) {
      const user = JSON.parse(pilotUser)
      // 如果用户atc_level为0，只允许访问申请页面
      if (user.atc_level === 0) {
        if (to.name !== 'application') {
          router.push('/application')
        }
      }
    }
  }
})

export default router 